'use client'

import { sendGTMEvent } from '@next/third-parties/google'
import { useEffect } from 'react'

export function SendSetEvent() {
  useEffect(() => {
    sendGTMEvent({
      eventName: 'Set',
      environment: 'Vitrine',
    })
  }, [])

  return null
}
